import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { requestAuthInterceptor, responseInterceptor, SPECTRUM_API_PATH, SPECTRUM_AUTH_API, provideSpectrumGuide } from 'common';
import { environment } from '../environments/environment';
import { LUCIDE_ICONS, LucideIconProvider } from 'lucide-angular';
import {
    LayoutDashboard, FileText, FilePlus2, FileSignature, FileCheck2, FileSearch,
    LayoutTemplate, Settings, Hash, Palette, Tags, ShieldCheck, QrCode,
    ChevronDown, ChevronRight, ChevronLeft, Plus, Check, X, Menu, Search, Filter,
    Download, Upload, Printer, Eye, Trash2, Save, Copy, Pencil, RefreshCw, History,
    AlertCircle, AlertTriangle, CheckCircle, XCircle, Info, Ban, Clock, Calendar,
    ArrowLeft, ArrowRight, MoreVertical, Users, UserRound, Building2, BookOpen,
    PanelLeftClose, PanelLeftOpen, Award, Stamp, Sparkles, LogOut, Bell
} from 'lucide-angular';

export const appConfig: ApplicationConfig = {
    providers: [
        provideSpectrumGuide({
            module: 'documents',
            title: 'Documents',
            manual: () => import('./help/documents.manual').then(m => m.DOCUMENTS_MANUAL)
        }),
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideBrowserGlobalErrorListeners(),
        provideRouter(routes),
        provideHttpClient(withInterceptors([requestAuthInterceptor, responseInterceptor])),
        provideAnimations(),
        { provide: SPECTRUM_API_PATH, useValue: environment.externalApiPath },
        { provide: SPECTRUM_AUTH_API, useValue: environment.authBaseUrl },
        {
            provide: LUCIDE_ICONS,
            multi: true,
            useValue: new LucideIconProvider({
                LayoutDashboard, FileText, FilePlus2, FileSignature, FileCheck2, FileSearch,
                LayoutTemplate, Settings, Hash, Palette, Tags, ShieldCheck, QrCode,
                ChevronDown, ChevronRight, ChevronLeft, Plus, Check, X, Menu, Search, Filter,
                Download, Upload, Printer, Eye, Trash2, Save, Copy, Pencil, RefreshCw, History,
                AlertCircle, AlertTriangle, CheckCircle, XCircle, Info, Ban, Clock, Calendar,
                ArrowLeft, ArrowRight, MoreVertical, Users, UserRound, Building2, BookOpen,
                PanelLeftClose, PanelLeftOpen, Award, Stamp, Sparkles, LogOut, Bell
            })
        }
    ]
};
